// ABOUTME: Screen for a signed-in blab-auth user who has no access to Alpha Finder
// ABOUTME: Offers sign-out only; an automatic login redirect would bounce straight back here

import type { BrowserAuth } from '@boundarylab/auth/browser';
import { Button, Card } from '@boundarylab/ui';
import { useSignOut } from '../hooks/useSignOut';
import { auth as defaultAuth } from '../lib/auth-client';

export function AccessDenied({ auth = defaultAuth }: { auth?: BrowserAuth }) {
  const { signOut, signingOut } = useSignOut(auth);

  return (
    <div className="flex h-screen items-center justify-center bg-slate-50">
      <Card variant="padded" className="max-w-md text-center">
        <p className="mb-4 text-slate-700">
          Your account has no access to Alpha Finder. Ask an admin to grant it.
        </p>
        <Button disabled={signingOut} onClick={() => void signOut()}>
          Sign out
        </Button>
      </Card>
    </div>
  );
}
